export enum CurrentStatuses {
    Matching = 1,
    Applied = 2,
    Paused = 3,
    NotMatching = 4,
    Placed = 5,
    HideStatusCard = 6,
    ADMIN = 7,
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/components/dashboard/components/mainPanel/components/currentAccountStatus/enums/currentStatuses.ts